<template>
  <draggable
    :list="modelValue"
    :item-key="itemKey"
    ghost-class="nc-drag-ghost"
    chosen-class="nc-drag-chosen"
    :animation="200"
    :delay="200"
    :delayOnTouchOnly="true"
    @end="onEnd"
  >
    <template #item="{ element, index }">
      <slot name="item" :element="element" :index="index" />
    </template>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'NcDragList',
  components: { draggable },
  props: {
    modelValue: { type: Array, required: true },
    itemKey: { type: String, default: 'uuid' },
  },
  emits: ['update:modelValue'],
  methods: {
    onEnd() {
      this.$emit('update:modelValue', [...this.modelValue]);
    },
  },
};
</script>

<!--
  NOTE: .nc-drag-ghost and .nc-drag-chosen are applied by vuedraggable at runtime
  on DOM elements outside Vue's scoped style system. The global definitions live in
  src/assets/tailwind.css so they take effect everywhere (including MeasurementTypeEditor
  which uses vuedraggable directly). No component-level <style> block is needed here.
-->
